(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/payfooter-react.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/payfooter-react.js');
"use strict";


const {
  Sum,
  Balance,
  ButtonList,
  TextList,
  LegalInfo
} = svs.tur.ReactPayfooter;
const reminder = new svs.tur.payfooter_reminder();
const Payfooter = _ref => {
  let {
    isBottom = true,
    sum,
    isShowingSum = true,
    balance,
    balanceLabel,
    children,
    buttons,
    texts,
    hasReminder = true,
    hasLeaveReminder = true,
    isLegalInfo,
    isFixed = false,
    reminderTrackingLabel,
    topContent = null
  } = _ref;
  const element = React.createRef();
  const pseudoFiller = React.createRef(); 
  const [inViewPort, setInViewPort] = React.useState(false);
  const [isSeen, setIsSeen] = React.useState(false);
  reminder.updateTrackingLabel(reminderTrackingLabel);
  React.useEffect(() => {
    if (!isFixed) {
      const observer = new IntersectionObserver(entries => {
        if (entries && entries[0]) {
          setInViewPort(entries[0].isIntersecting);
        }
      });
      observer.observe(element.current);
      if (isBottom && inViewPort) {
        gsap.from(element.current, {
          duration: 0.2,
          y: '100%'
        });
      }
      return () => {
        observer.disconnect();
        reminder.removeDomElements();
      };
    }
  }, []);
  React.useEffect(() => {
    let timeout;
    if (isFixed) {
      pseudoFiller.current.style.height = "".concat(element.current.clientHeight, "px");
    } else if (hasReminder && !isSeen) {
      if (!inViewPort) {
        reminder.show(null, hasLeaveReminder);
      } else {
        timeout = setTimeout(() => {
          setIsSeen(true);
        }, 1000);
      }
    }
    return () => {
      clearTimeout(timeout);
    };

  }, [balance, hasReminder, sum, inViewPort]);
  return React.createElement(React.Fragment, null, isFixed && React.createElement("div", {
    ref: pseudoFiller
  }), React.createElement("div", {
    className: "payfooter payfooter-default dots ".concat(isFixed ? 'payfooter-fixed' : '', " dots-tur ").concat(isBottom ? 'payfooter-block' : ''),
    ref: element
  }, React.createElement("div", {
    className: "payfooter-inner"
  }, topContent, React.createElement(Balance, {
    label: balanceLabel,
    value: balance
  }), isShowingSum && React.createElement(Sum, {
    value: sum
  }), React.createElement(ButtonList, {
    buttonOptions: buttons,
    sum: sum
  }), React.createElement(TextList, {
    textOptions: texts
  }), isLegalInfo && React.createElement(LegalInfo, null), React.createElement("div", null, children))));
};
svs.tur.ReactPayfooter.Payfooter = Payfooter;

 })(window);